import moment, { Moment } from 'moment';
import React, { useState } from 'react';

import DateSelectRange from '../../elements/DateSelectRange';
import ShowMetrics, { TYPE_METRICS, TimeRangeName } from '../../helpers/ShowMetrics';

function TicketsMetrics({ url }: { url: string }) {
    const [range, setRange] = useState<TimeRangeName>('this-month');
    const [startDate, setStartDate] = useState<Moment>(moment().startOf('month'));
    const [endDate, setEndDate] = useState<Moment>(moment().endOf('month'));
    const timeRange = { range, startDate, endDate };

    return (
        <div>
            <div className="row no-gutters">
                <div className="dashboard_date-select">
                    <DateSelectRange
                        range={range}
                        setRange={setRange}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                    />
                </div>
            </div>
            <div className="row metrics">
                <ShowMetrics
                    url={url}
                    path="lottery_ticket/new"
                    label="New Lottery Tickets"
                    typeMetrics={TYPE_METRICS.VALUE_METRIC}
                    timeRange={timeRange}
                />
                <ShowMetrics
                    url={url}
                    path="lottery_ticket/per_day"
                    label="Lottery Tickets per Day"
                    typeMetrics={TYPE_METRICS.TREND_METRIC}
                    timeRange={timeRange}
                />
                <ShowMetrics
                    url={url}
                    path="lottery_ticket/per_lottery"
                    label="Lottery Tickets Per Lottery"
                    typeMetrics={TYPE_METRICS.PARTITION_METRIC}
                    timeRange={timeRange}
                />
                <ShowMetrics
                    url={url}
                    path="lottery_ticket/per_status"
                    label="Lottery Tickets Per Status"
                    typeMetrics={TYPE_METRICS.PARTITION_METRIC}
                    timeRange={timeRange}
                />
                <ShowMetrics
                    url={url}
                    path="lottery_ticket/sale_sum"
                    label="Sale Sum"
                    typeMetrics={TYPE_METRICS.TREND_METRIC}
                    timeRange={timeRange}
                />
            </div>
        </div>
    );
}

export default TicketsMetrics;
